import Vue from 'vue'
import VueRouter from 'vue-router'
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject)
  }
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/Login.vue')
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('../views/Register.vue')
  },
  {
    path: '/resetPassword',
    name: 'resetPassword',
    component: () => import('../views/ResetPassword.vue')
  },
  {
    path: '/',
    name: 'Layout',
    component: () => import('../views/Layout.vue'),
    redirect: '/account/package',
    children: [
      {
        path: 'myai',
        name: 'myAi',
        component: () => import('@/views/work/myAi.vue')
      },
      {
        path: 'custom',
        name: 'custom',
        component: () => import('@/views/work/custom.vue')
      },
      {
        path: 'customai',
        name: 'customai',
        component: () => import('@/views/work/customAi.vue')
      }
    ]
  },
  // {
  //   path: '/limitactivities',
  //   name: 'Layout',
  //   component: () => import('../views/Layout.vue'),
  //   redirect: '/limitactivities/limit',
  //   children: [
  //     {
  //       path: 'limit',
  //       name: 'limit',
  //       component: () => import('@/views/limitActivities/index.vue')
  //     }
  //   ]
  // },
  {
    path: '/collaboration',
    name: 'Layout',
    component: () => import('../views/Layout.vue'),
    redirect: '/collaboration/team',
    children: [
      {
        path: 'team',
        name: 'team',
        component: () => import('@/views/collaboration/team.vue')
      }
    ]
  },
  {
    path: '/account',
    name: 'Layout',
    component: () => import('../views/Layout.vue'),
    redirect: '/account/accountcenter',
    children: [
      {
        path: 'accountcenter',
        name: 'accountcenter',
        component: () => import('@/views/account/accountCenter.vue')
      },
      {
        path: 'package',
        name: 'package',
        component: () => import('@/views/account/package.vue')
      },
      {
        path: 'bill',
        name: 'bill',
        component: () => import('@/views/account/bill.vue')
      },{
        path: 'points',
        name: 'points',
        component: () => import('@/views/account/points.vue')
      }
    ]
  },
  {
    path: '/footer',
    name: 'footer',
    component: () => import('../views/Footer.vue')
  },
]

const router = new VueRouter({
  routes
})

export default router
